import axios from '../helpers/axios';
import { logError } from '../services';
import {
  ISalesToolsContract,
  ISalesToolsContractDetails,
  ISalesToolsContractTemplate,
  ISalesToolsContractTemplateEditSession,
  ISalesToolsContractTemplateTokens
} from '../models';

const baseUrl = '/api/sales/tools/contract-management';

export const getSalesToolsContracts = async (): Promise<ISalesToolsContract[]> => {
  try {
    const { data } = await axios.get(baseUrl);
    return data;
  } catch (error) {
    logError(error, 'getSalesToolsContracts failed');
    return Promise.reject(error);
  }
};

export const getSalesToolsContractTemplates = async (
  buildDocumentTypeId: number
): Promise<ISalesToolsContractTemplate[]> => {
  try {
    const { data } = await axios.get(`${baseUrl}/${buildDocumentTypeId}/templates`);
    return data;
  } catch (error) {
    logError(error, 'getContractVersions failed');
    return Promise.reject(error);
  }
};

export const getSalesToolsContractHistory = async (
  buildDocumentTypeId: number
): Promise<ISalesToolsContractTemplate[]> => {
  try {
    const { data } = await axios.get(`${baseUrl}/${buildDocumentTypeId}/templates/history`);
    return data;
  } catch (error) {
    logError(error, 'getSalesToolsContractHistory failed');
    return Promise.reject(error);
  }
};

export const updateSalesToolsContractTemplate = async (
  buildDocumentTypeId: number,
  payload: { activePandaDocTemplateId: string }
): Promise<any> => {
  try {
    const { data } = await axios.put(`${baseUrl}/${buildDocumentTypeId}/templates`, payload);
    return data;
  } catch (error: any) {
    logError(error, 'setSalesToolsContractTemplateActive failed');
    return Promise.reject(error?.response?.data);
  }
};

export const downloadSalesToolsContractTemplate = async (
  buildDocumentTypeId: number | string,
  pandaDocTemplateId: number | string
): Promise<any> => {
  try {
    const data = await axios.get(
      `${baseUrl}/${buildDocumentTypeId}/templates/${pandaDocTemplateId}`,
      {
        responseType: 'blob'
      }
    );
    return data;
  } catch (error) {
    logError(error, 'downloadSalesToolsContractTemplate failed');
    return Promise.reject(error);
  }
};

export const uploadEditSalesToolsContractTemplate = async (
  buildDocumentTypeId: number,
  payload: FormData
): Promise<any> => {
  try {
    const { data } = await axios.post(`${baseUrl}/${buildDocumentTypeId}/templates`, payload);
    return data;
  } catch (error: any) {
    logError(
      { error, payload: { buildDocumentTypeId } },
      'updateEditSalesToolsContractTemplate failed'
    );
    return Promise.reject(error?.response?.data);
  }
};

export const getEditSalesToolsContractTemplateSession = async (
  buildDocumentTypeId: number,
  pandaDocTemplateId: string
): Promise<ISalesToolsContractTemplateEditSession> => {
  try {
    const { data } = await axios.post(
      `${baseUrl}/${buildDocumentTypeId}/templates/${pandaDocTemplateId}/sessions`
    );
    return data;
  } catch (error: any) {
    logError(
      { error, payload: { pandaDocTemplateId } },
      'getEditSalesToolsContractTemplateSession failed'
    );
    return Promise.reject(error?.response?.data);
  }
};

export const getSalesToolsContractsTokens = async (
  buildDocumentTypeId: number | string
): Promise<ISalesToolsContractTemplateTokens[]> => {
  try {
    const { data } = await axios.get(`${baseUrl}/${buildDocumentTypeId}/templates/tokens`);
    return data;
  } catch (error) {
    logError(error, 'getSalesToolsContractsTokens failed');
    return Promise.reject(error);
  }
};

export const updateDocumentFromPandaDocTemplate = async (
  buildDocumentTypeId: number | string,
  pandaDocTemplateId: number | string
): Promise<any> => {
  try {
    const { data } = await axios.post(
      `${baseUrl}/${buildDocumentTypeId}/templates/${pandaDocTemplateId}/update-template`
    );
    return data;
  } catch (error) {
    logError(error, 'updateDocumentFromPandaDocTemplate failed');
    return Promise.reject(error);
  }
};

export const getSalesToolsContractDetails = async (
  buildDocumentTypeId: number | string,
  pandaDocTemplateId: number | string
): Promise<ISalesToolsContractDetails> => {
  try {
    const { data } = await axios.get(
      `${baseUrl}/${buildDocumentTypeId}/templates/${pandaDocTemplateId}/details`
    );
    return data;
  } catch (error) {
    logError(error, 'getSalesToolsContractDetails failed');
    return Promise.reject(error);
  }
};
